import NetworkManager from '../../services/network-service.js';
import { cpBaseUrl, GET, POST, PUT } from '@constants/generic-constants.js';

export const sellersListingApi = (params = '') => {
  return new Promise((resolve, reject) => {
    let url = `${cpBaseUrl}/stores${params}`;
    NetworkManager.performRequest(url, null, GET)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const createSellerApi = (payload) => {
  return new Promise((resolve, reject) => {
    let url = `${cpBaseUrl}/stores`;
    NetworkManager.performRequest(url, payload, POST)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const updateSellerApi = ({ id = '', payload = {} }) => {
  return new Promise((resolve, reject) => {
    let url = `${cpBaseUrl}/stores/${id}`;
    NetworkManager.performRequest(url, payload, PUT)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const sellerDetailApi = (id) => {
  return new Promise((resolve, reject) => {
    let url = `${cpBaseUrl}/stores/${id}`;
    NetworkManager.performRequest(url, null, GET)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const updateSellerStatusApi = (id, payload) => {
  return new Promise((resolve, reject) => {
    let url = `${cpBaseUrl}/stores/${id}/change_status`;
    NetworkManager.performRequest(url, payload, PUT)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const findUserApi = (params) => {
  return new Promise((resolve, reject) => {
    let url = `${cpBaseUrl}/auth/find_user${params}`;
    NetworkManager.performRequest(url, null, GET)
      .then(({ data }) => {
        resolve({ data });
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const impersonateSellerApi = (payload) => {
  return new Promise((resolve, reject) => {
    let url = `${cpBaseUrl}/auth/impersonate`;
    NetworkManager.performRequest(url, payload, POST)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const categoriesApi = (params = '', signal) => {
  return new Promise((resolve, reject) => {
    let url = `${cpBaseUrl}/categories?sort[name]=asc&f[display]=true${params?.replace('?', '&')}`;
    NetworkManager.performRequest(url, null, GET, signal)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const retryOnboardSellerApi = (id) => {
  return new Promise((resolve, reject) => {
    let url = `${cpBaseUrl}/stores/${id}/retry_onboard`;
    NetworkManager.performRequest(url, null, PUT)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const reSyncProductsApi = (id) => {
  return new Promise((resolve, reject) => {
    let url = `${cpBaseUrl}/stores/${id}/resync_onboard`;
    NetworkManager.performRequest(url, null, PUT)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const sendWelcomeEmailApi = (id) => {
  return new Promise((resolve, reject) => {
    let url = `${cpBaseUrl}/stores/${id}/send_welcome_email`;
    NetworkManager.performRequest(url, null, PUT)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const publishSellerApi = (id) => {
  return new Promise((resolve, reject) => {
    let url = `${cpBaseUrl}/stores/${id}/publish`;
    NetworkManager.performRequest(url, null, PUT)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const getJarvisClientApi = ({ phoneNumber = '' }) => {
  return new Promise((resolve, reject) => {
    let url = `${cpBaseUrl}/stores/get_jarvis_client?phone=${phoneNumber}`;
    NetworkManager.performRequest(url, null, GET)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const viewPhoneNumberApi = (storeId) => {
  return new Promise((resolve, reject) => {
    const url = `${cpBaseUrl}/stores/${storeId}/mobile`;
    NetworkManager.performRequest(url, null, GET)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const approveStoreProductsApi = (storeId) => {
  return new Promise((resolve, reject) => {
    const url = `${cpBaseUrl}/stores/${storeId}/approve_products`;
    NetworkManager.performRequest(url, null, PUT)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const moderationApproveApi = (id) => {
  return new Promise((resolve, reject) => {
    const url = `${cpBaseUrl}/stores/${id}/approve_moderation`;
    NetworkManager.performRequest(url, null, PUT)
      .then(({ data }) => resolve(data))
      .catch((error) => reject(error));
  });
};

export const moderationRejectApi = (id) => {
  return new Promise((resolve, reject) => {
    const url = `${cpBaseUrl}/stores/${id}/reject_moderation`;
    NetworkManager.performRequest(url, null, PUT)
      .then(({ data }) => resolve(data))
      .catch((error) => reject(error));
  });
};
export const storeModerationApi = (params) => {
  return new Promise((resolve, reject) => {
    let url = `${cpBaseUrl}/stores?f[in_moderation]=true&sort[updated_at]=desc&${params}`;
    NetworkManager.performRequest(url, null, GET)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};


export const getStoreCategoriesApi = (id) => {
  return new Promise((resolve, reject) => {
    let url = `${cpBaseUrl}/stores/${id}/categories`;
    NetworkManager.performRequest(url, null, GET)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
